<template>
    <layout>
        <HeaderAdminComponent :title="fruit.name"></HeaderAdminComponent>

        <div class="py-5 bg-light_yellow px-10"> 
            <div class="container relative px-4 pt-5 mx-auto">
                <ButtonComponent 
                    content="Atrás" 
                    :icon="'arrow_back_ios'"
                    :link="'/admin'"
                    type="2"
                />
                <div class="justify-between py-5 md:flex">
                    <div class="justify-center md:flex md:justify-start">
                        <div class="flex justify-center">
                            <img
                                class="object-cover w-16 h-16 ml-4 border-2 rounded-full border-enriqueto_green"
                                :src="fruit.image"
                                alt=""
                            />
                            <h2 class="px-4 text-xl font-bold text-enriqueto_green">{{fruit.name}} <br> <span class="text-2xl ">{{usePriceFormat(fruit.price)}}</span></h2>
                        </div>
                        <div class="flex content-center justify-center">
                            <div class="mx-2 text-center text-enriqueto_green">Movimiento 24H <br> <p class="h-auto px-4 py-2 mt-1 font-bold text-white rounded-xl" :class="movementBackground(fruit.increase)">{{formatMovement(fruit.increase)}}</p></div>
                            <div class="mx-2 text-center text-enriqueto_green">Movimiento 7D <br> <p class="h-auto px-4 py-2 mt-1 font-bold text-white rounded-xl" :class="movementBackground(fruit.week_increase)">{{formatMovement(fruit.week_increase)}}</p></div>
                        </div>
                    </div>
                    <div>
                        <div class="flex flex-wrap justify-center px-1 py-2 mt-3 bg-white rounded-lg shadow md:mr-8">
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==7}" v-on:click="getReportsByDays(7)">7D</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==15}" v-on:click="getReportsByDays(15)">15D</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==30}" v-on:click="getReportsByDays(30)">1M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==90}" v-on:click="getReportsByDays(90)">3M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==180}" v-on:click="getReportsByDays(180)">6M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==365}" v-on:click="getReportsByDays(365)">1Y</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==500}" v-on:click="getReportsByDays(500)">ALL</button>
                        </div>
                    </div>
                </div>
                <div class="w-full h-96">
                    <vue3-chart-js
                        ref="chartRef"
                        :id="lineGraphChart.id"
                        :type="lineGraphChart.type"
                        :data="lineGraphChart.data"
                        :options="lineGraphChart.options"
                        @before-render="beforeRenderLogic"
                    ></vue3-chart-js>
                </div>
            </div>
        </div>
        <div class="container relative px-4 pt-5 mx-auto">
            <h2 class=" my-7 text-enriqueto_green">Categorias</h2>
            <AddToCategory :categories='fruit.categories' :fruit_id="fruit.id" />
        </div>
        <div class="container relative px-4 pt-5 mx-auto">
            <TaxonomyAssignmentManager
                :fruit-id="fruit.id"
                :terms="all_taxonomy_terms"
                :assigned-term-ids="taxonomy_term_ids"
            />
        </div>
        <RegionalPriceManager
            :fruit-id="fruit.id"
            :regional-prices="regional_prices"
            :regional-comparison-enabled="fruit.regional_comparison_enabled"
            :regional-comparison-globally-enabled="regional_comparison_globally_enabled"
        />
        <div class="container relative px-4 pt-5 mx-auto">
            <div class="w-full px-5">
                <h2 class=" my-7 text-enriqueto_green">Editar fruta</h2>
                <FruitForm :fruit="fruit" />
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '../../../Components/Shared/LayoutAdmin.vue'
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import useApi from '../../../Services/useApi'
import usePriceFormat, { usePriceCovert } from '../../../Services/usePriceFormat'
import { useStore } from 'vuex'
import FruitForm from '../../../Components/Forms/FruitForm.vue'
import AddToCategory from '../../../Components/Shared/AddToCategory.vue'
import ButtonComponent from '../../../Components/Shared/ButtonComponent.vue'
import HeaderAdminComponent from "../../../Components/Shared/HeaderAdminComponent.vue";
import RegionalPriceManager from '../../../Components/Market/RegionalPriceManager.vue'
import TaxonomyAssignmentManager from '../../../Components/Classification/TaxonomyAssignmentManager.vue'

export default {
    components: { Link,Layout,Vue3ChartJs,FruitForm,AddToCategory,ButtonComponent,HeaderAdminComponent,RegionalPriceManager,TaxonomyAssignmentManager},
    props: ['fruit','fruits','all_taxonomy_terms','taxonomy_term_ids','regional_prices','regional_comparison_globally_enabled'],
    setup (props) {
    const formatMovement = value => value === null || value === undefined ? '—' : `${value}%`
    const movementBackground = value => value === null || value === undefined
        ? 'bg-light_gray'
        : (value >= 0 ? 'bg-enriqueto_green' : 'bg-red')
    const chartRef = ref(null)
    const active_filter = ref(7)
    const api = useApi()
    const store = useStore()
    watch(()=>store.state.currency, function() {
        getReportsByDays(active_filter.value)
    });
    let value_report = props.fruit.last_reports.map(({ value }) => usePriceCovert(value,store.state.currency))
    let date_report = props.fruit.last_reports.map(({ created_at }) => created_at)
    const lineGraphChart = {
        id: 'lineGraph'+props.fruit.id,
        type: 'line',
        data: {
            labels: date_report,
            datasets: [{ 
                data: value_report,
                borderColor: "#4F4F4F",
                fill: true,
                pointBackgroundColor: "#4F4F4F",
                pointRadius: 2.5,
                backgroundColor: 'rgba(242, 153, 74, 0.4)',
                hoverBackgroundColor: 'rgba(33, 150, 83, 0.6)',
                borderWidth: 1
            }
            ]
        },
        options: {
            elements: {
                line: {
                    tension: 0.6
                }
            },
            plugins: {
                legend: {
                    display: false,
                } 
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
            mode: 'index',
            intersect: false
            },
            scales: {
            x: {
                display: true,
            },
            y: {
                display: true,
            }
            }
        },
    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    const getReportsByDays = (days)=>{
        active_filter.value = days
        api.getReports(props.fruit.id,days)
        .then(function (response) {
            console.log(response.reports);
            lineGraphChart.data.labels = response.reports.map(({ created_at }) => created_at)
            lineGraphChart.data.datasets[0].data = response.reports.map(({ value }) => {return usePriceCovert(value,store.state.currency)});
            chartRef.value.update(250)
        })
    }

    const compareWith = (event)=>{
        Inertia.visit('/fruit/compare/'+props.fruit.id+'/'+event.target.value)
    }

        return {
            lineGraphChart,
            beforeRenderLogic,
            getReportsByDays,
            chartRef,
            compareWith,
            active_filter,
            usePriceFormat,
            formatMovement,
            movementBackground
        }
    },
}
</script>

<style>

</style>
